export default __webpack_public_path__ + "static/media/message.8f310045.svg";